import visit from "@/core/visit"
import settings from "./settings"
import { firePixelEvents } from "./facebook"
import { sendSegments } from "./google-analytics"
import { EventResponseMessage } from "@/types"
import { fetch } from "@/core/fetch"
import bus from "./api/bus"

let marketingConsent: boolean | undefined = undefined

bus.on("marketingallowed", allowed => {
  marketingConsent = allowed
})

export function resetConsent() {
  marketingConsent = undefined
}

export default async function processBrowserQueue() {
  if (!settings.browserQueueActive || marketingConsent === false) {
    return
  }

  const url = new URL(`${settings.server}/event/queue`)
  url.searchParams.append("m", settings.account)
  url.searchParams.append("c", visit.getCustomerId()!)

  const response = await fetch(url.toString())
  if (response.status === 200) {
    const data = (await response.json()) as EventResponseMessage
    firePixelEvents(data)
    sendSegments(data)
  }
}
